import classNames from "classnames"
import { format, subHours } from "date-fns"
import download from "downloadjs"
import { Button } from "primereact/button"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dialog } from "primereact/dialog"
import { Dropdown } from "primereact/dropdown"
import React, { useEffect, useRef, useState } from "react"
import { GrDownload } from "react-icons/gr"
import { Api } from "../../../../services/api"
import { DropdownPague } from "../../../../styles/primeReactConfig"


export function ExportarCobrancas({ tipo, close, toast }) {
  const buttonRef = useRef()
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState('')
  const [registros, setRegistros] = useState([]);
  const [tipoRelatorio, setTipoRelatorio] = useState(tipo);
  const [filterOptions] = useState([
    { label: "Todos", value: "all" },
    { label: "Documento", value: "documento" },
    { label: "Nome", value: "nome" },
    { label: "Código do Cliente", value: "codigocliente" },
    { label: "Em Aberto", value: "aberto" },
    { label: "Protestados", value: "enviado" },
    { label: "Pago", value: "pago" },
    { label: "Pago (Cliente)", value: "pagocliente" },
    { label: "Pago no Cartório", value: "pagoCartorio" },
    { label: "Em Processamento", value: "processamento" },
    { label: "Acordo não Pago", value: "cobrancaquebrada" },
    { label: "Inativados", value: "inativa" },
  ]);


  useEffect(() => {
    const visualizaRegistros = async () => {
      setLoading(true)
      try {
        const { data } = await Api.get(`relatorio/consultarRelatorioCobrancas${tipoRelatorio ? `?tipo=${tipoRelatorio}` : ''}`)
        setRegistros(data.relatorios)
      } catch (error) {
        if (!error.response)
          toast('error', 'Erro de comunicação com o servidor')
        if (error.response.status === 403) {
          toast('error', 'Nenhuma exportação encontrada')
          setRegistros([])
        }
        else
          toast('error', 'Erro ao consultar registros de exportações')
      } finally {
        setLoading(false)
      }
    }
    visualizaRegistros()
  }, [reload])

  function nomesTipo(rowData) {
    //console.log(filterOptions,rowData.tipo)
    const nomeFiltro = filterOptions.filter((e) => e.value === rowData.tipo)
    if(nomeFiltro.length > 0)
      return nomeFiltro[0].label
    else
      return 'desconhecido'
  }

  const baixarRelatorios = async (e) => {
    //console.log(e)
    setLoadingDownload(e.relatorio_id)
    if (e.arquivos.length > 0)
      for (let i = 0; i < e.arquivos.length; i++) {
        const arquivo_id = e.arquivos[0].blob_nome
        try {
          const { data } = await Api.get(`relatorio/baixarRelatorioCobrancas/${arquivo_id}`)
          if(data){
            const buffer = atob(data).toString('latin1')
            download(buffer, `Relatorio_Cobrancas_${nomesTipo(e)}_${format(subHours(new Date(e.created_at), 3), 'dd-MM-yyyy')}.csv`)
          }
          else 
          toast('error', 'Erro: arquivo corrompido')
        } catch (error) {
          console.log(error.response)
          toast('error', 'Erro ao baixar exportação')
        } finally {
          setLoadingDownload('')
        }
      }
    else {
      toast('error', 'Exportação indisponível')
    }
  }

  return (

    <Dialog
      visible
      header="Histórico de Exportações"
      pt={{
        root: 'w-screen md:w-[70vw] max-h-[80vh]',
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80')
      }}
      onHide={() => close()}
    >
      <div className="flex flex-col justify-center text-center gap-3">
        <h4><b>Filtro da exportação de cobranças</b></h4>
        <div className="w-full flex justify-content-center ">
          <Dropdown
            value={tipoRelatorio}
            options={filterOptions}
            className="w-full"
            pt={DropdownPague}
            onChange={(e) => {
              setTipoRelatorio(e.value);
              setReload(prevReload => !prevReload);
            }}
            showClear
          ></Dropdown>
        </div>
        <DataTable
          value={registros}
          header="Registros"
          loading={loading}
          scrollable
          scrollHeight="50vh"
          emptyMessage='Nemhum relatório gerado.'
        >
          <Column header="Exportação Registro" field="relatorio_id" />
          <Column header="Data Geração" field="data_criacao" />
          <Column header="Data Processado" field="data_fim_processo" />
          <Column header="Filtro" body={(rowData) => nomesTipo(rowData)} />
          <Column header="Parâmetro" field="filtro" />
          <Column header="Baixar"
            body={(rowData) =>
              !rowData.relatorio_status ?
                <div className='customer-badge status-proposal text-center'>
                  <p>EM PROCESSAMENTO</p>
                </div>
                :
                <Button
                  ref={buttonRef}
                  id={rowData.relatorio_id}
                  rounded
                  icon={<GrDownload />}
                  tooltip={'Baixar relatório'}
                  disabled={!rowData.relatorio_status}
                  loading={loadingDownload === rowData.relatorio_id}
                  onClick={() => baixarRelatorios(rowData)}
                />
            } />
        </DataTable>
      </div>
    </Dialog>
  )
}